export enum CastRole {
  Director = 'Director',
  Actor = 'Actor',
}
